module.exports = __webpack_public_path__ + "assets/header-stars-c64393.svg";